const getErrorMassage = (error) => 'Network Error';
export default getErrorMassage;
